// Ported from the Polaris kit: src/components/ui/badge/index.js.
// Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
// Change the design in the kit first, then re-port.
import { cva } from 'class-variance-authority';

export { default as Badge } from './Badge.vue';

export const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-full border border-solid border-polaris-border px-2 py-0.5 type-polaris-small-label w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-polaris-ring focus-visible:ring-polaris-ring/50 focus-visible:ring-[3px] aria-invalid:ring-polaris-destructive/20 dark:aria-invalid:ring-polaris-destructive/40 aria-invalid:border-polaris-destructive transition-[color,box-shadow] overflow-hidden',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-polaris-primary text-polaris-primary-foreground [a&]:hover:bg-polaris-primary/90',
        secondary:
          'border-transparent bg-polaris-secondary text-polaris-secondary-foreground [a&]:hover:bg-polaris-secondary/90',
        destructive:
          'border-transparent bg-polaris-destructive text-polaris-destructive-foreground [a&]:hover:bg-polaris-destructive/90 focus-visible:ring-polaris-destructive/20 dark:focus-visible:ring-polaris-destructive/40',
        outline:
          'text-polaris-foreground [a&]:hover:bg-polaris-accent [a&]:hover:text-polaris-accent-foreground',
        // Polaris patch: status badges. The text carries the meaning; color only supports it.
        success:
          'border-transparent bg-polaris-success text-polaris-success-foreground',
        warning:
          'border-transparent bg-polaris-warning text-polaris-warning-foreground',
        info: 'border-transparent bg-polaris-info text-polaris-info-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
